export default {
  name: "ColorHeightProjectionRender",
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      options: ['A', 'B', 'C', 'D'],
      selected: null,
      legendItems: [{
        label: '黄色 = 0',
        color: '#facc15'
      }, {
        label: '红色 = 1',
        color: '#ef4444'
      }, {
        label: '绿色 = 2',
        color: '#22c55e'
      }, {
        label: '蓝色 = 3',
        color: '#3b82f6'
      }]
    };
  },
  computed: {
    arrowText() {
      const mapping = {
        LEFT: '→',
        RIGHT: '←',
        FRONT: '↑',
        BACK: '↓'
      };
      return mapping[this.data?.viewDirection] || '→';
    },
    arrowClass() {
      return `arrow-${(this.data?.viewDirection || 'LEFT').toLowerCase()}`;
    }
  },
  watch: {
    data() {
      this.init();
    },
    review: {
      deep: true,
      handler() {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.selected = this.reviewMode ? this.review?.answer || null : null;
    },
    heightColor(height) {
      const colors = ['#facc15', '#ef4444', '#22c55e', '#3b82f6'];
      return colors[height] || '#ffffff';
    },
    onChoose(option) {
      if (this.reviewMode) {
        return;
      }
      this.selected = option;
      this.$emit('answer', option);
    },
    optionClass(option) {
      if (!this.reviewMode) {
        return {
          active: this.selected === option
        };
      }
      return {
        correct: this.data?.rightAnswer === option,
        wrong: this.review?.answer === option && this.data?.rightAnswer !== option,
        active: this.review?.answer === option
      };
    }
  },
  mounted() {
    this.init();
  }
};